export enum GlobalVideosRoutes {
  BASE = 'videos'
}
